module.exports = __webpack_public_path__ + "img/invert_space_logo.4f976723.png";